import { useTranslation } from 'react-i18next';

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-medal-line',
      title: t('feature1Title'),
      description: t('feature1Desc'),
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-team-line',
      title: t('feature2Title'),
      description: t('feature2Desc'),
      color: 'from-indigo-500 to-indigo-600'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: t('feature3Title'),
      description: t('feature3Desc'),
      color: 'from-cyan-500 to-cyan-600'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('feature4Title'),
      description: t('feature4Desc'),
      color: 'from-teal-500 to-teal-600'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
            مميزاتنا
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            {t('featuresTitle')}
          </h2>
          <p className="text-lg text-gray-600">
            {t('featuresSubtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-gray-800 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>

              {/* Decorative Element */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-t-2xl"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}